import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { class: "form-group" };
const _hoisted_2 = { class: "position-relative" };
const _hoisted_3 = {
    key: 0,
    class: "dropdown-menu show w-100 page-picker-dropdown"
};
const _hoisted_4 = ["onClick"];
const _hoisted_5 = { class: "page-picker-option-body" };
const _hoisted_6 = { class: "page-picker-option-name" };
const _hoisted_7 = { class: "page-picker-option-assistant" };
const _hoisted_8 = {
    key: 0,
    class: "page-picker-empty"
};
const _hoisted_9 = {
    key: 1,
    class: "page-picker-more"
};
const _hoisted_10 = {
    key: 0,
    class: "mt-3"
};
const _hoisted_11 = { class: "selected-tokens" };
const _hoisted_12 = { class: "token-text" };
const _hoisted_13 = ["onClick"];
import axios from 'axios';
import { computed, onMounted, ref } from 'vue';
const MAX_RESULTS = 10;
export default /*@__PURE__*/ _defineComponent({
    __name: 'PageAssistantSelector',
    props: {
        modelValue: {}
    },
    emits: ["update:modelValue"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const loading = ref(true);
        const isOpen = ref(false);
        const searchQuery = ref('');
        const pages = ref([]);
        const inputEl = ref(null);
        const currentPageId = window.location.pathname.match(/\/pages\/(\d+)/)?.[1] ?? null;
        const selectedTokens = computed({
            get: () => props.modelValue ? props.modelValue.split(',').map(t => t.trim()).filter(Boolean) : [],
            set: (value) => emit('update:modelValue', value.join(',')),
        });
        const matchedPages = computed(() => {
            const selectedPageIds = new Set(selectedTokens.value.map(parsePageId).filter((id) => id !== null));
            const available = pages.value.filter(p => String(p.page_id) !== String(currentPageId) &&
                !selectedPageIds.has(p.page_id));
            const query = searchQuery.value.trim().toLowerCase();
            if (!query) {
                return available;
            }
            return available.filter(page => page.page_name.toLowerCase().includes(query) ||
                page.assistant_name.toLowerCase().includes(query));
        });
        const filteredPages = computed(() => matchedPages.value.slice(0, MAX_RESULTS));
        const hasMoreResults = computed(() => matchedPages.value.length > MAX_RESULTS);
        let pagesRequest = null;
        function fetchGameChangerPages() {
            if (!pagesRequest) {
                pagesRequest = axios.get('/api/pages', {
                    params: {
                        with_assistants: 1,
                        layout: 'OpenResponseQuestionAI',
                        sort: 'updated_at',
                        direction: 'desc',
                    },
                })
                    .then(response => {
                    const data = response.data.data ?? [];
                    return data.map((page) => ({
                        page_id: page.id,
                        page_name: page.name || page.title || '',
                        assistant_id: page.assistant?.id ?? '',
                        assistant_name: page.assistant?.name ?? 'Unknown',
                    }));
                })
                    .catch(error => {
                    pagesRequest = null;
                    throw error;
                });
            }
            return pagesRequest;
        }
        onMounted(async () => {
            try {
                pages.value = await fetchGameChangerPages();
            }
            catch (error) {
                if (axios.isAxiosError(error)) {
                    console.error('[PageAssistantSelector] Error loading pages:', error.response?.status, error.response?.data);
                }
                else {
                    console.error('[PageAssistantSelector] Error loading pages:', error);
                }
            }
            finally {
                loading.value = false;
            }
        });
        function parsePageId(token) {
            const match = token.match(/%%thread\.(\d+)\./);
            return match ? parseInt(match[1], 10) : null;
        }
        function selectPage(page) {
            const token = `%%thread.${page.page_id}.asst_local_${page.assistant_id}%%`;
            if (!selectedTokens.value.includes(token)) {
                selectedTokens.value = [...selectedTokens.value, token];
            }
            searchQuery.value = '';
            isOpen.value = false;
            setTimeout(() => inputEl.value?.blur(), 0);
        }
        function removeToken(idx) {
            selectedTokens.value = selectedTokens.value.filter((_, i) => i !== idx);
        }
        function getPageNameFromToken(token) {
            const pageId = parsePageId(token);
            return pages.value.find(p => p.page_id === pageId)?.page_name ?? 'Unknown Page';
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _cache[12] || (_cache[12] = _createElementVNode("label", {
                    for: "page-picker-input",
                    class: "control-label"
                }, "Select Previous Conversation Page", -1)),
                _cache[13] || (_cache[13] = _createElementVNode("small", { class: "d-block text-muted mb-2" }, "Only Game Changer assistant pages are available for selection.", -1)),
                _createElementVNode("div", _hoisted_2, [
                    _cache[7] || (_cache[7] = _createElementVNode("i", {
                        class: "fa fa-search page-picker-search-icon",
                        "aria-hidden": "true"
                    }, null, -1)),
                    _withDirectives(_createElementVNode("input", {
                        id: "page-picker-input",
                        ref_key: "inputEl",
                        ref: inputEl,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((searchQuery).value = $event)),
                        type: "text",
                        class: "form-control page-picker-input",
                        placeholder: "Search pages or click to see all...",
                        autocomplete: "off",
                        onFocus: _cache[1] || (_cache[1] = ($event) => (isOpen.value = true)),
                        onBlur: _cache[2] || (_cache[2] = ($event) => (isOpen.value = false))
                    }, null, 544), [
                        [_vModelText, searchQuery.value]
                    ]),
                    _createElementVNode("i", {
                        class: _normalizeClass(["fa fa-chevron-down page-picker-caret", { 'is-open': isOpen.value }]),
                        "aria-hidden": "true"
                    }, null, 2),
                    (isOpen.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredPages.value, (page) => {
                                return (_openBlock(), _createElementBlock("button", {
                                    key: page.page_id,
                                    type: "button",
                                    class: "dropdown-item page-picker-option",
                                    onClick: ($event) => (selectPage(page)),
                                    onMousedown: _cache[3] || (_cache[3] = _withModifiers(() => { }, ["prevent"]))
                                }, [
                                    _cache[5] || (_cache[5] = _createElementVNode("span", { class: "page-picker-option-icon" }, [
                                        _createElementVNode("i", {
                                            class: "fa fa-comment",
                                            "aria-hidden": "true"
                                        })
                                    ], -1)),
                                    _createElementVNode("span", _hoisted_5, [
                                        _createElementVNode("span", _hoisted_6, _toDisplayString(page.page_name), 1),
                                        _createElementVNode("span", _hoisted_7, [
                                            _cache[4] || (_cache[4] = _createElementVNode("span", { class: "page-picker-option-label" }, "Assistant", -1)),
                                            _createTextVNode(" " + _toDisplayString(page.assistant_name), 1)
                                        ])
                                    ])
                                ], 40, _hoisted_4));
                            }), 128)),
                            (filteredPages.value.length === 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [...(_cache[6] || (_cache[6] = [
                                        _createElementVNode("i", {
                                            class: "fa fa-search",
                                            "aria-hidden": "true"
                                        }, null, -1),
                                        _createElementVNode("span", null, "No pages found", -1)
                                    ]))]))
                                : _createCommentVNode("", true),
                            (hasMoreResults.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_9, " Refine your search to see more "))
                                : _createCommentVNode("", true)
                        ]))
                        : _createCommentVNode("", true)
                ]),
                (selectedTokens.value.length > 0 && !loading.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                        _cache[10] || (_cache[10] = _createElementVNode("label", { class: "control-label selected-pages-label" }, " Selected Pages (will be saved with page): ", -1)),
                        _cache[11] || (_cache[11] = _createElementVNode("small", { class: "d-block text-muted mb-2" }, "Token format: %%thread.{pageId}.asst_local_{assistantId}%% — These conversation threads will be included as context when this page loads.", -1)),
                        _createElementVNode("div", _hoisted_11, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedTokens.value, (token, idx) => {
                                return (_openBlock(), _createElementBlock("div", {
                                    key: idx,
                                    class: "token-badge"
                                }, [
                                    _cache[9] || (_cache[9] = _createElementVNode("i", {
                                        class: "fa fa-comment token-icon",
                                        "aria-hidden": "true"
                                    }, null, -1)),
                                    _createElementVNode("span", _hoisted_12, _toDisplayString(getPageNameFromToken(token)), 1),
                                    _createElementVNode("button", {
                                        type: "button",
                                        class: "token-remove",
                                        onClick: ($event) => (removeToken(idx)),
                                        title: "Remove",
                                        "aria-label": "Remove"
                                    }, [...(_cache[8] || (_cache[8] = [
                                            _createElementVNode("i", {
                                                class: "fa fa-times",
                                                "aria-hidden": "true"
                                            }, null, -1)
                                        ]))], 8, _hoisted_13)
                                ]));
                            }), 128))
                        ])
                    ]))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
